import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalService } from 'app/services/global.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['../app.component.css', './settings.component.css']
})
export class SettingsComponent {

    constructor(
        public router: Router,
        public global: GlobalService
    ) {
        router.events.subscribe((route:any) => {
            //console.log(route);
            if ((route instanceof NavigationEnd) && (route.url == "/dashboard")) {
                if (this.global.loggedUser) {
                    if (this.global.loggedUser.groups.length) {
                        if (this.global.loggedUser.groups[0] == this.global.EMPRESA) {
                            this.router.navigate(["/dashboard/empresas"]);
                        }
                        if (this.global.loggedUser.groups[0] == this.global.ALUNO) {
                            this.router.navigate(["/painel"]);
                        }
                        else if (this.global.loggedUser.groups[0] == this.global.EDUCADOR) {
                            this.router.navigate(["/dashboard/educadores"]);
                        }
                    }
                }
                else {
                    this.router.navigate(["/register"]);
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts